export default "__VITE_ASSET__BixDhsa7__"